import { TStatusBadgeProps } from '@treezor/design-system';

import { TCardStatusColor } from '@/features/cards/store/models/card.model';

export const cardColor: Record<TCardStatusColor, string> = {
  ACTIVE: 'linear-gradient(180deg, #36C0AB 0%, #75DDCC 100%)',
  INACTIVE: 'linear-gradient(180deg, #F19F5F 0%, #FFC08F 100%)',
  BLOCKED: 'linear-gradient(180deg, #F62B4D 0%, #FF5A76 100%)',
  EXPIRED: 'linear-gradient(180deg, #979797 0%, #C4C4C4 100%)',
  LOCK_INTERNAL: 'linear-gradient(180deg, #F62B4D 0%, #FF5A76 100%)',
  CUSTOM: 'linear-gradient(180deg, #F19F5F 0%, #FFC08F 100%)',
  DESTROYED: 'linear-gradient(180deg, #979797 0%, #C4C4C4 100%)',
};

export const cardStatusColor: Record<TCardStatusColor, string> = {
  ACTIVE: '#36C0AB',
  INACTIVE: '#F19F5F',
  BLOCKED: '#F62B4D',
  EXPIRED: '#979797',
  LOCK_INTERNAL: '#F62B4D',
  CUSTOM: '#F19F5F',
  DESTROYED: '#979797',
};

export const cardStatusBadgeColor: Record<TCardStatusColor, TStatusBadgeProps['color']> = {
  ACTIVE: 'green',
  INACTIVE: 'orange',
  BLOCKED: 'red',
  EXPIRED: 'gray',
  LOCK_INTERNAL: 'red',
  CUSTOM: 'mediumOrange',
  DESTROYED: 'darkRed',
};
